import ApiService from '../apiservice'

export default class GrupoAtividadeService extends ApiService {

  constructor() {
    super('/grupo-atividade')
  }

	cadastrar(grupo) {
		return this.post('/',grupo);
	}

	listar(empresaId) {
		return this.get(`/listar/${empresaId}`);
	}

	listarPorProcesso(processoId) {
		return this.get(`/listar-por-processo/${processoId}`);
	}

	listarGruposAtividadePorProcesso(processoId) {
		return this.get(`/listar-por-processo/${processoId}`);
	}

	alterar(grupo) {
		return this.put('/',grupo);
	}

	excluir(id) {
		return this.delete(`/${id}`);
	}
}
